import { motion } from 'motion/react'
import type { InputHTMLAttributes } from 'react'
import styles from './Toggle.module.css'

export interface ToggleProps extends InputHTMLAttributes<HTMLInputElement> {}

export default function Toggle({ checked, onChange, ...props }: ToggleProps) {
	return (
		<label className={styles.label}>
			<input type="checkbox" className={styles.input} checked={checked} onChange={onChange} />
			<motion.span
				animate={{
					backgroundColor: checked ? 'var(--bg-jike-yellow)' : 'var(--bg-on-body-2)',
				}}
				transition={{ duration: 0.3 }}
				className={styles.track}
			/>
			<motion.span
				animate={{
					x: checked ? 27 : 0,
				}}
				transition={{
					type: 'spring',
					stiffness: 500,
					damping: 30,
				}}
				className={styles.thumb}
			/>
		</label>
	)
}
